import { createContext, type FC, type PropsWithChildren, useEffect, useState } from 'react';

import { type DeviceID, generateDeviceId } from '../server/deviceId';
import { Environment } from '../server/utils/environment';

export type DeviceIdContextType = {
	deviceId: DeviceID;
	env: Environment;
};

export const DeviceIdContext = createContext<DeviceIdContextType | null>(null);

interface Props extends PropsWithChildren {
	environment?: Environment;
}

export const DeviceIdProvider: FC<Props> = ({ children, environment }) => {
	const env = environment || Environment.NonProduction;
	const [deviceId, setDeviceId] = useState<DeviceID>();

	useEffect(() => {
		const deviceId = generateDeviceId({ env });
		setDeviceId(deviceId);
	}, [env]);

	return <DeviceIdContext.Provider value={{ deviceId, env }}>{children}</DeviceIdContext.Provider>;
};
